import React from "react";
import { useSelector } from "react-redux";
import { Container, Typography } from "@mui/material";

import ContractorInfoHeader from '../components/ContractorInfoHeader'
import ContractorPersonalData from "../components/ContractorPersonalData";

import DriverPersonalData from "../../driver/components/DriverPersonalData";
import DriverRadioField from "../../driver/components/DriverRadioField";

import ContractorAdress from "../components/ContractorAdress";
import ContractorRadioField from "../components/ContractorRadioField";
import ContractorTaxAdress from "../components/ContractorTaxAdress";

import ContractorContact from "../components/ContractorContact";

import ContractorButton from "../components/ContractorButton";

import { trackEventStep3View } from '../../../utils/analytics';

const ContractorForm= () => {

  React.useEffect(() => {
    trackEventStep3View().catch(e => console.warn("Error en analítica (Vista Step 3):", e));
  }, []);

  const esConductorHabitual = useSelector(
    (state) => state.contractor.formValues.esConductorHabitual
  );

  const esMismoDomicilioFiscal = useSelector(
    (state) => state.contractor.formValues.esMismoDomicilioFiscal
  );

  return (
    <Container
        maxWidth="md"
        disableGutters={{
            xs: true,
            md: false
        }}
        sx={{
            py: 2,
            px: 2
        }}>
        <ContractorInfoHeader />
        <DriverRadioField />
        {esConductorHabitual === "No" && <DriverPersonalData />}
        <ContractorPersonalData />
        <ContractorAdress />
        <ContractorRadioField />
        {esMismoDomicilioFiscal === "No" && <ContractorTaxAdress />}
        <ContractorContact />
        <ContractorButton />
    </Container>
  );
};

export default ContractorForm;
